function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { ThemeProvider } from '@veneer/theme';
import ProgressIndicator from '../progress_indicator';
import useTableContext from '../table/use_table_context';
import TableHeadCell from '../table_head_cell';
import TableRow from '../table_row';
import TableSelectionCell from '../table_selection_cell';
import useEffect from '../utils/use_effect';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SELECTION_STATES_TO_CHECKED = {
  all: true,
  none: false,
  indeterminated: 'indeterminated'
};
var defaultComponent = 'thead';
var TableHead = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    component: Component = defaultComponent
  } = _ref;
  var {
    columnResize,
    columns,
    hasActions,
    hasFilters,
    i18n,
    isSinglePage,
    loading,
    onSelectAll,
    onSelectAllPageItems,
    rowSelectAllState,
    rowSelector,
    showClearAllFilters,
    showFilters,
    theme
  } = useTableContext();
  var tableHeadSelectionRef = React.useRef(null);
  var tableFilterSelectionRef = React.useRef(null);
  useEffect(() => {
    if (!isSinglePage) return;
    var {
      current: tableHeadNode
    } = tableHeadSelectionRef;
    var {
      current: tableFilterSelNode
    } = tableFilterSelectionRef;
    if (tableHeadNode && tableFilterSelNode) {
      tableFilterSelNode.style.width = "".concat(tableHeadNode.offsetWidth, "px");
      tableFilterSelNode.style.minWidth = "".concat(tableHeadNode.offsetWidth, "px");
    }
  }, [isSinglePage, showClearAllFilters]);
  var style = useStyles({
    isSinglePage,
    theme
  });
  var tableClearButtonProps = showClearAllFilters ? {
    customStyle: style.clearAllFiltersButton,
    sortable: false
  } : {};
  var handleOnSelectAllPageItems = React.useCallback(event => {
    if (onSelectAllPageItems) {
      onSelectAllPageItems(event);
    } else if (onSelectAll) {
      onSelectAll(event);
    }
  }, [onSelectAll, onSelectAllPageItems]);
  return ___EmotionJSX(Component, {
    css: style.component,
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, ___EmotionJSX(TableRow, {
    variant: "head"
  }, rowSelector && ___EmotionJSX(TableSelectionCell, {
    label: i18n.selectAllPageItems,
    component: "th",
    isHeadRow: true,
    onSelectAll: handleOnSelectAllPageItems,
    ref: tableHeadSelectionRef,
    selected: SELECTION_STATES_TO_CHECKED[rowSelectAllState || 'none']
  }), columns.map(c => {
    var {
      id,
      label,
      sortable
    } = c;
    return ___EmotionJSX(TableHeadCell, {
      id: id,
      key: id,
      resizableHeadCell: true,
      sortable: sortable
    }, label);
  }), columnResize && ___EmotionJSX(TableHeadCell, null), hasActions && ___EmotionJSX("th", {
    "aria-label": i18n.actionButton
  })), hasFilters && showFilters && ___EmotionJSX(TableRow, {
    variant: "head"
  }, rowSelector && ___EmotionJSX(TableHeadCell, _extends({
    ref: tableFilterSelectionRef
  }, tableClearButtonProps)), columns.map(_ref2 => {
    var {
      id,
      filter
    } = _ref2;
    return ___EmotionJSX(TableHeadCell, {
      filter: filter,
      id: id,
      key: "table-filter-".concat(id)
    });
  })), loading && ___EmotionJSX("tr", null, ___EmotionJSX("th", {
    colSpan: columns.length + (rowSelector ? 1 : 0)
  }, ___EmotionJSX(ThemeProvider, {
    shape: "sharp"
  }, ___EmotionJSX(ProgressIndicator, {
    appearance: "linear"
  })))));
});
TableHead.displayName = 'TableHead';
export default TableHead;